import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const RegisterModal = ({show, onHide}) => {
    const handleClose = () => {
        if (onHide) {
            onHide();
        }
    };

return (
    <Modal show={show} onHide={handleClose} centered size='lg'>
        <Modal.Header closeButton>
        <Modal.Title>Registration Form for Participation</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pt-0 hero-register'>
        <iframe src="https://forms.gle/yT87PXVkMQ4E3qRk7" width="100%" height="800" frameBorder="0" marginHeight="0" marginWidth="0">Loading...</iframe>
        </Modal.Body>
        {/* <Modal.Footer className='py-0'>
        <button className="btn btn-primary" onClick={handleClose}>
            Close
        </button>
        </Modal.Footer> */}
    </Modal>
  );
};

export default RegisterModal;